import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import imgStep1 from '../assets/img-step-1.png'
import imgColor1 from '../assets/img-corte-1.png'
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp'
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'


const Step3 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.clarity || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "VVS2",
      value1: 3375,
      value2: 9000,
      value3: 10125,
      value4: 31500,
      title: "Claridad VVS2",
      description: "Detalles casi imperceptibles",
      image: imgStep1,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "VS1",
      value1: 2250,
      value2: 6750,
      value3: 7650,
      value4: 20250,
      title: "Claridad VS1",
      description: "Pureza excelente y equilibrada",
      image: imgColor1
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "VS2", 
      value1: 1125,
      value2: 4500,
      value3: 5175,
      value4: 11250,
      title: "Claridad VS2",
      description: "Pureza excelente y equilibrada",
      image: imgStep1
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "SI1",
      value1: 0,
      value2: 2250,
      value3: 2700,
      value4: 7875,
      title: "Claridad SI1",
      description: "Belleza accesible con pequeñas inclusiones",
      image: imgColor1
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('clarity', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Escoge la Pureza del Diamante (clarity)</h2>
            <p className='text-size-medium text-color-grey'>Recomendamos no bajar de SI1 porque pueden ser apreciables a simple vista las impurezas de la piedra.</p>
            <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="clarity"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
            </div>
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={imgAnilloBodasPrev} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Claridad</p>
                <p className='text-size-large text-color-white'>Por favor selecciona la claridad</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step3;
